const MOBILE_APP_CATEGORY = 'mobile-app-promotion'

export const MOBILE_APP_EVENTS = {
  APPSTORE_BUTTON_CLICK: {
    action: 'appstore-button-click',
    category: MOBILE_APP_CATEGORY,
  },
}
